import React from 'react'
import {Account} from '../../types/app-types'
import LoaderInline from '../common/LoaderInline'
import {Link} from 'react-router-dom'
import {getAccountPath} from '../../services/navigation'
import {formatDate} from '../../services/utils'
interface AccountListCardProps {
  accountsQuery: {
    data?: Account[]
    isLoading: boolean
  }
}

interface AccountListItemProps {
  account: Account
}

const AccountListItem = ({account}: AccountListItemProps) => {
  const {
    id,
    propertyName,
    reservationId,
    roomNumber,
    checkinDate,
    checkoutDate
  } = account
  const accountPath = getAccountPath(reservationId)
  return (
    <li key={id} className="w-full mb-1">
      <Link to={accountPath} className="flex link link-primary no-underline">
        <div
          className="account-list-item bg-gray-100 text-gray-800 font-medium
        rounded-lg p-2 w-full cursor-pointer border border-gray-200 hover:bg-gray-300 relative"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 sm:grid-cols-1 sm:grid-rows-4 gap-1 p-1">
            <div className="font-bold whitespace-nowrap md:text-left">
              {propertyName}
            </div>
            <div className="md:text-right md:text-sm">
              Stay ID: {reservationId}
            </div>
            <div className="text-gray-700 md:justify-self-start md:align-self-end flex justify-between items-end">
              Unit {roomNumber}
            </div>
            <div
              className="md:text-right md:justify-self-end
            md:align-self-end flex justify-between  md:text-sm whitespace-nowrap overflow-x-hidden"
            >
              Start: {formatDate(new Date(checkinDate))}
              <br />
              End: {formatDate(new Date(checkoutDate))}
            </div>
          </div>
        </div>
      </Link>
    </li>
  )
}

const AccountListCard = ({accountsQuery}: AccountListCardProps) => {
  const isLoading = accountsQuery?.isLoading
  const accounts = accountsQuery?.data
  return (
    <div className="card-default w-full">
      <div className="card-body-default">
        <h1 className="card-header">Leases</h1>
        {isLoading ? <LoaderInline text="Loading accounts..." /> : ''}

        {!isLoading && accounts?.length ? (
          <ul>
            {accounts.map((account: Account) => {
              return <AccountListItem key={account.id} account={account} />
            })}
          </ul>
        ) : (
          ''
        )}

        {!isLoading && (!accounts || !accounts?.length) ? (
          <p>No accounts found</p>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default AccountListCard
